export const TIDS = {
  // Nav
  navLogo: "nav-logo",
  navHome: "nav-home",
  navDashboard: "nav-dashboard",
  navAbout: "nav-about",
  navAuth: "nav-auth-button",
  navUser: "nav-user-menu",
  navLogout: "nav-logout",

  // Hero
  heroTitle: "hero-title",
  heroSubtitle: "hero-subtitle",
  heroCurrentChoghadiya: "hero-current-choghadiya",
  heroCountdown: "hero-countdown",
  heroExploreBtn: "hero-explore-btn",

  // Location
  locSearchInput: "location-search-input",
  locResultsList: "location-results-list",
  locResultItem: (i) => `location-result-${i}`,
  locGeolocateBtn: "geolocate-button",
  locCurrent: "current-location",
  locSaveBtn: "save-location-button",

  // Timeline
  timelineDay: "timeline-day",
  timelineNight: "timeline-night",
  timelineSlot: (kind, i) => `timeline-${kind}-slot-${i}`,
  dateNext: "date-next",
  datePrev: "date-prev",
  dateToday: "date-today",
  datePicker: "date-picker",

  // About
  aboutSection: "about-section",

  // Auth
  authModal: "auth-modal",
  authEmail: "auth-email-input",
  authPassword: "auth-password-input",
  authName: "auth-name-input",
  authSubmit: "auth-submit",
  authToggle: "auth-toggle-mode",
  authClose: "auth-close",

  // Dashboard
  dashSavedList: "dashboard-saved-list",
  dashNotifyToggle: "dashboard-notify-toggle",
  dashSendTestBtn: "dashboard-send-test-btn",
  dashDeleteLoc: (i) => `dashboard-delete-loc-${i}`,
  dashSetPrimary: (i) => `dashboard-primary-loc-${i}`,

  // Account settings
  acctChangePwOpen: "acct-change-pw-open",
  acctChangePwCurrent: "acct-change-pw-current",
  acctChangePwNew: "acct-change-pw-new",
  acctChangePwConfirm: "acct-change-pw-confirm",
  acctChangePwSubmit: "acct-change-pw-submit",
  acctDeleteOpen: "acct-delete-open",
  acctDeletePassword: "acct-delete-password",
  acctDeleteConfirmText: "acct-delete-confirm-text",
  acctDeleteSubmit: "acct-delete-submit",
};
